
import { createClient, SupabaseClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.VITE_SUPABASE_URL;
const supabaseAnonKey = process.env.VITE_SUPABASE_ANON_KEY;

export const isSupabaseConfigured = !!(supabaseUrl && supabaseAnonKey && supabaseUrl !== "");

let supabase: SupabaseClient;

if (!isSupabaseConfigured) {
  // A dummy client to prevent crashes on initial render before the error screen shows.
  const dummyAuth = {
    getSession: () => Promise.resolve({ data: { session: null }, error: null }),
    onAuthStateChange: () => ({ data: { subscription: { unsubscribe: () => {} } } }),
    signInWithOAuth: () => Promise.resolve({ data: null, error: new Error("Supabase is not configured. Please check your .env file.") }),
    signOut: () => Promise.resolve({ error: null }),
  };
  const dummyFrom = () => ({
      select: () => Promise.resolve({ data: null, error: new Error("Supabase is not configured.") }),
      insert: () => Promise.resolve({ data: null, error: new Error("Supabase is not configured.") }),
      update: () => Promise.resolve({ data: null, error: new Error("Supabase is not configured.") }),
      delete: () => Promise.resolve({ data: null, error: new Error("Supabase is not configured.") }),
  });
  const dummyFunctions = {
      invoke: () => Promise.resolve({ data: null, error: new Error("Supabase is not configured.") })
  };

  supabase = {
    auth: dummyAuth,
    from: dummyFrom,
    functions: dummyFunctions,
    // Add other top-level methods if needed to prevent crashes
    channel: () => ({
        on: () => ({
            subscribe: () => ({ unsubscribe: () => {} })
        }),
        subscribe: () => ({ unsubscribe: () => {} })
    }),
    removeChannel: () => Promise.resolve('ok'),
  } as any;

} else {
  supabase = createClient(supabaseUrl, supabaseAnonKey);
}

export { supabase };
